import { User, Document } from '../types';

export const mockUsers: User[] = [
  { tin: '22345678901234', name: 'Кожомкулов Темирлан Асанович' },
  { tin: '12345678905678', name: 'Токтогулова Нургуль Эрмековна' },
  { tin: '22345679001111', name: 'Токтобаев Бакыт Суйунбекович' },
  { tin: '12345679002222', name: 'Токтосунова Айзада Каныбековна' },
  { tin: '22345679003333', name: 'Токтогонов Эмиль Эсенбекович' },
  { tin: '12345679004444', name: 'Токтоматова Жыпара Абдыкадыровна' },
  { tin: '22345679005555', name: 'Токтомушев Нурлан Касымбекович' },
  { tin: '12345679006666', name: 'Токтосунбаева Гулзат Мирлановна' },
  { tin: '22345679007777', name: 'Токтогул уулу Азамат' },
  { tin: '12345679008888', name: 'Токтобубу кызы Айгерим' },
  { tin: '29876543210987', name: 'Джунусов Нурбек Каримович' },
  { tin: '19876543210123', name: 'Джунусова Гулжан Мамытовна' },
  { tin: '29876543210234', name: 'Джумабаев Адилет Талантбекович' },
  { tin: '19876543210345', name: 'Джумагулова Назира Болотовна' },
  { tin: '29876543210456', name: 'Джусупов Мирлан Абдиллаевич' },
  { tin: '19876543210567', name: 'Джумакадырова Алтынай Султановна' },
  { tin: '29876543210678', name: 'Джунушалиев Эркин Асанович' },
  { tin: '19876543210789', name: 'Джапарова Салтанат Мамбетовна' },
  { tin: '29876543210890', name: 'Джээнбеков Канатбек Токтосунович' },
  { tin: '19876543210901', name: 'Джумабекова Бермет Кубатовна' },
  { tin: '21122334455667', name: 'Асанов Бактыбек Калыкович' },
  { tin: '11122334455999', name: 'Асанова Айнура Эсенбековна' },
  { tin: '21122334455111', name: 'Асылбеков Талантбек Нурдинович' },
  { tin: '11122334455222', name: 'Асылбекова Жибек Султановна' },
  { tin: '21122334455333', name: 'Асанбеков Санжар Болотбекович' },
  { tin: '11122334455444', name: 'Асанбаева Гулнара Азаматовна' },
  { tin: '21122334455555', name: 'Асылбашев Медербек Токтосунович' },
  { tin: '11122334455666', name: 'Асылбекова Назгуль Бакытовна' },
  { tin: '21122334455777', name: 'Асан уулу Нурдин' },
  { tin: '11122334455888', name: 'Асел кызы Айжан' },
  { tin: '25544332211009', name: 'Бакиров Улукбек Маматович' },
  { tin: '15544332211887', name: 'Бакирова Чолпон Асыловна' },
  { tin: '25544332211111', name: 'Бакытбеков Нурлан Эркинович' },
  { tin: '15544332211222', name: 'Бакытбекова Динара Жумабековна' },
  { tin: '25544332211333', name: 'Бакасов Руслан Алмазович' },
  { tin: '15544332211444', name: 'Бакасова Жаныл Бейшеновна' },
  { tin: '25544332211555', name: 'Бакытов Мирлан Болотович' },
  { tin: '15544332211666', name: 'Бакытова Айсулуу Касымовна' },
  { tin: '25544332211777', name: 'Бактыбек уулу Эрмек' },
  { tin: '15544332211999', name: 'Бакыт кызы Нурай' },
  { tin: '27766554433221', name: 'Эрмеков Азамат Султанович' },
  { tin: '17766554433998', name: 'Эрмекова Кундуз Нурлановна' },
  { tin: '27766554433111', name: 'Эсенбаев Талант Мирланович' },
  { tin: '17766554433222', name: 'Эсенбаева Айгерим Талгатовна' },
  { tin: '27766554433333', name: 'Эрматов Бекболот Канатбекович' },
  { tin: '17766554433444', name: 'Эрматова Алтынай Жумабековна' },
  { tin: '27766554433555', name: 'Эсеналиев Нуралы Асанбекович' },
  { tin: '17766554433666', name: 'Эсеналиева Жаныл Каныбековна' },
  { tin: '27766554433777', name: 'Эркин уулу Бакыт' },
  { tin: '17766554433888', name: 'Эрке кызы Айжамал' },
  { tin: '23322110099887', name: 'Касымов Мирлан Болотбекович' },
  { tin: '13322110099123', name: 'Касымова Жанар Алмазовна' },
  { tin: '23322110099111', name: 'Каныбеков Азамат Нурдинович' },
  { tin: '13322110099222', name: 'Каныбекова Гулзат Эркиновна' },
  { tin: '23322110099333', name: 'Камчыбеков Улан Маматович' },
  { tin: '13322110099444', name: 'Камчыбекова Бермет Токтосуновна' },
  { tin: '23322110099555', name: 'Калыков Эмиль Асанбекович' },
  { tin: '13322110099666', name: 'Калыкова Назира Султановна' },
  { tin: '23322110099777', name: 'Канат уулу Темир' },
  { tin: '13322110099999', name: 'Кымбат кызы Айнура' },
  { tin: '26677889900112', name: 'Маматов Нурлан Бакытбекович' },
  { tin: '16677889900223', name: 'Маматова Элиза Каныбековна' },
  { tin: '26677889900334', name: 'Мамбетов Адилет Жумабекович' },
  { tin: '16677889900445', name: 'Мамбетова Салтанат Эркиновна' },
  { tin: '26677889900556', name: 'Манасов Тилек Асанбекович' },
  { tin: '16677889900667', name: 'Манасова Гулайым Нурдиновна' },
  { tin: '26677889900778', name: 'Максатбеков Руслан Маратович' },
  { tin: '16677889900889', name: 'Максатбекова Айсулуу Болотовна' },
  { tin: '26677889900990', name: 'Медербек уулу Нурбек' },
  { tin: '16677889900110', name: 'Медина кызы Жылдыз' },
  { tin: '24455667788990', name: 'Сатыбалдиев Бакыт Токтогулович' },
  { tin: '14455667788112', name: 'Сатыбалдиева Айжан Эсенбековна' },
  { tin: '24455667788223', name: 'Султанов Канат Мирланович' },
  { tin: '14455667788334', name: 'Султанова Нурай Алмазовна' },
  { tin: '24455667788445', name: 'Сулайманов Дастан Асылбекович' },
  { tin: '14455667788556', name: 'Сулайманова Айгерим Каныбековна' },
  { tin: '24455667788667', name: 'Садыров Эрмек Нурлан уулу' },
  { tin: '14455667788778', name: 'Садырова Жанара Болот кызы' },
  { tin: '24455667788889', name: 'Султан уулу Адилет' },
  { tin: '14455667788001', name: 'Сымбат кызы Бегимай' },
  { tin: '22233445566778', name: 'Омуралиев Нурбек Токтосунович' },
  { tin: '12233445566889', name: 'Омуралиева Чынара Маматовна' },
  { tin: '22233445566990', name: 'Орозбаев Талантбек Калыкович' },
  { tin: '12233445566112', name: 'Орозбаева Гулнур Асанбековна' },
  { tin: '22233445566223', name: 'Осмонов Азат Эркинович' },
  { tin: '12233445566334', name: 'Осмонова Назгуль Султановна' },
  { tin: '22233445566445', name: 'Орозалиев Мирлан Жумабекович' },
  { tin: '12233445566556', name: 'Орозалиева Айнура Бакытовна' },
  { tin: '22233445566667', name: 'Омурбек уулу Санжар' },
  { tin: '12233445566770', name: 'Олжобу кызы Айзада' },
  { tin: '28899001122334', name: 'Усенов Эркин Мамбетович' },
  { tin: '18899001122445', name: 'Усенова Динара Алмазовна' },
  { tin: '28899001122556', name: 'Уметалиев Руслан Токтогулович' },
  { tin: '18899001122667', name: 'Уметалиева Жыпара Каныбековна' },
  { tin: '28899001122778', name: 'Усубалиев Нурдин Асанбекович' },
  { tin: '18899001122889', name: 'Усубалиева Алтынай Эсенбековна' },
  { tin: '28899001122990', name: 'Урматбеков Бекболот Султанович' },
  { tin: '18899001122112', name: 'Урматбекова Гулзат Нурлановна' },
  { tin: '28899001122330', name: 'Улукбек уулу Тилек' },
  { tin: '18899001122001', name: 'Умутай кызы Назира' },
];

export const mockDocuments: Document[] = [
  {
    id: '1',
    issuedBy: 'Токтогулова Нургуль Эрмековна',
    issuedByTin: '12345678905678',
    issuedTo: 'Асанов Бактыбек Калыкович',
    issuedToTin: '21122334455667',
    status: 'pending',
    issuedByStatus: 'signed',
    issuedToStatus: 'pending',
    fileName: 'договор_аренды.pdf',
    date: '2025-10-23',
  },
  {
    id: '2',
    issuedBy: 'Эрмеков Азамат Султанович',
    issuedByTin: '27766554433221',
    issuedTo: 'Бакирова Чолпон Асыловна',
    issuedToTin: '15544332211887',
    status: 'signed',
    issuedByStatus: 'signed',
    issuedToStatus: 'signed',
    fileName: 'акт_приема_передачи.pdf',
    date: '2025-10-22',
  },
  {
    id: '3',
    issuedBy: 'Касымова Жанар Алмазовна',
    issuedByTin: '13322110099123',
    issuedTo: 'Джунусов Нурбек Каримович',
    issuedToTin: '29876543210987',
    status: 'rejected',
    issuedByStatus: 'signed',
    issuedToStatus: 'rejected',
    fileName: 'счет_фактура_102345.pdf',
    date: '2025-10-21',
  },
  {
    id: '4',
    issuedBy: 'Маматов Нурлан Бакытбекович',
    issuedByTin: '26677889900112',
    issuedTo: 'Султанова Нурай Алмазовна',
    issuedToTin: '14455667788334',
    status: 'pending',
    issuedByStatus: 'pending',
    issuedToStatus: 'pending',
    fileName: 'договор_поставки.pdf',
    date: '2025-10-20',
  },
  {
    id: '5',
    issuedBy: 'Омуралиева Чынара Маматовна',
    issuedByTin: '12233445566889',
    issuedTo: 'Усенов Эркин Мамбетович',
    issuedToTin: '28899001122334',
    status: 'signed',
    issuedByStatus: 'signed',
    issuedToStatus: 'signed',
    fileName: 'протокол_согласования.pdf',
    date: '2025-10-19',
  },
  {
    id: '6',
    issuedBy: 'Асанова Айнура Эсенбековна',
    issuedByTin: '11122334455999',
    issuedTo: 'Токтобаев Бакыт Суйунбекович',
    issuedToTin: '22345679001111',
    status: 'signed',
    issuedByStatus: 'signed',
    issuedToStatus: 'signed',
    fileName: 'спецификация_услуг.pdf',
    date: '2025-10-18',
  },
  {
    id: '7',
    issuedBy: 'Сатыбалдиев Бакыт Токтогулович',
    issuedByTin: '24455667788990',
    issuedTo: 'Манасова Гулайым Нурдиновна',
    issuedToTin: '16677889900667',
    status: 'pending',
    issuedByStatus: 'signed',
    issuedToStatus: 'pending',
    fileName: 'техническое_задание.pdf',
    date: '2025-10-17',
  },
  {
    id: '8',
    issuedBy: 'Бакытбекова Динара Жумабековна',
    issuedByTin: '15544332211222',
    issuedTo: 'Орозбаев Талантбек Калыкович',
    issuedToTin: '22233445566990',
    status: 'rejected',
    issuedByStatus: 'signed',
    issuedToStatus: 'rejected',
    fileName: 'заявка_на_оплату.pdf',
    date: '2025-10-16',
  },
];
